export default __webpack_public_path__ + "static/media/CustomerInquiryBanner.d09be73c.png";